<template>
  <unicom-layout-pagina-cartao
    :filtroAplicado="filtroAplicado"
    :semFiltro="semFiltro"
    :arrTexto="arrTexto"
    @limpar-filtro="$emit('limpar-filtro')"
  >
    <div slot="breadcrumb">
      <unicom-layout-breadcrumb
        v-observe-visibility="visibilityChanged"
        :titulo="titulo"
        :subtitulo="subtitulo"
        :breadcrumb="breadcrumb"
        :icone="icone"
        :iconeSvg="iconeSvg"
      />
    </div>
    <div slot="cartao" v-if="cartaoCustom">
      <slot name="cartao" />
    </div>
    <slot />
  </unicom-layout-pagina-cartao>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
      default: ""
    },
    subtitulo: {
      type: String,
      default: ""
    },
    breadcrumb: {
      type: Array,
      default: () => []
    },
    icone: {
      type: String,
      default: ""
    },
    iconeSvg: {
      type: Object,
      default: null
    },
    cartaoCustom: {
      type: Boolean,
      default: false
    },
    semFiltro: {
      type: Boolean,
      default: true
    },
    arrTexto: {
      type: Array,
      default: () => []
    },
    filtroAplicado: {
      type: String,
      default: "Nenhum filtro aplicado na tabela."
    }
  },
  methods: {
    visibilityChanged(isVisible) {
      if (!isVisible) {
        this.$store.commit("setMostrarBread", true);
        this.$store.commit("setBread", this.breadcrumb);
      } else {
        this.$store.commit("setMostrarBread", false);
      }
    }
  }
};
</script>
